export const DIALOG_CLASSES = {
  paper: 'my-32 mx-24 w-full max-w-none h-full rounded-8 border border-border',
};

export const MOBILE_DIALOG_CLASSES = {
  paper: 'my-0 mx-0 w-full max-w-none max-h-full h-full rounded-8 border border-border',
};
